import React, { useCallback, useEffect, useMemo, useState } from "react";
import { CSVLink } from "react-csv";
import UIkit from "uikit";

import StorageService from "../../../../services/storage.service";
import StorageMenu from "../menu";

export default function LowStockReport() {
  const [rows, setRows] = useState([]);

  const loadReport = useCallback(async () => {
    try {
      const resp = await StorageService.lowStockReport({ page: 0, per: 1000 });
      setRows(resp.data?.paginated || []);
    } catch (err) {
      UIkit.notification("Failed to load low stock report.", "error");
    }
  }, []);

  useEffect(() => {
    document.title = "Low Stock Items - RueBaRue";
    loadReport();
  }, [loadReport]);

  const exportRows = useMemo(() => rows.map((row) => ({
    Item: row.item_name,
    SKU: row.sku || "",
    Location: row.location_name,
    "Current Qty": row.current_quantity,
    "Minimum Qty": row.minimum_quantity,
    "Suggested Reorder Qty": row.suggested_reorder_quantity || "",
  })), [rows]);

  return (
    <section id="dashboard-template">
      <div id="hms-page-title" className="uk-flex uk-flex-between uk-flex-middle">
        <h1 className="uk-heading-small uk-margin-remove">Low Stock Items</h1>
      </div>

      <div id="hms-main-body">
        <StorageMenu />
        <h3 className="uk-margin-small-top uk-margin-small-bottom">Low Stock Report</h3>
        <div className="uk-flex uk-flex-right uk-margin-small-bottom">
          <CSVLink data={exportRows} filename="low-stock-items.csv">
            <button className="download" type="button">
              <img src="/images/download.svg" alt="Download CSV" uk-tooltip="Download CSV" />
            </button>
          </CSVLink>
        </div>

        <div className="uk-card uk-card-small uk-card-default hms-form-card card-without-filters">
          <div className="uk-overflow-auto">
            <table className="uk-table uk-table-hover uk-table-divider hms-table">
              <thead>
                <tr>
                  <th className="uk-table-expand">Item</th>
                  <th>Location</th>
                  <th>Current Qty</th>
                  <th>Minimum Qty</th>
                  <th>Suggested Reorder Qty</th>
                </tr>
              </thead>
              <tbody>
                {rows.length === 0 && (
                  <tr><td colSpan={5}><div className="uk-text-center uk-padding-small uk-text-meta">No low stock items found.</div></td></tr>
                )}
                {rows.map((row) => (
                  <tr key={`${row.location_id}-${row.item_id}`}>
                    <td className="semi-bold-font">{row.item_name}<div className="uk-text-meta">{row.sku || "No SKU"}</div></td>
                    <td>{row.location_name}</td>
                    <td>{row.current_quantity}</td>
                    <td>{row.minimum_quantity}</td>
                    <td>{row.suggested_reorder_quantity ?? "-"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
}
